import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { CustomNotificationService } from './custom.notification.service';
import { PermissionService } from './permissions.service';

@Injectable({
  providedIn: 'root',
})
export class ReportsGuard implements CanActivate {
  constructor(
    private readonly permissionService: PermissionService,
    private readonly router: Router,
    private readonly notification: CustomNotificationService,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const hasAccess =
      this.permissionService.hasPermission('admin_contacts') ||
      this.permissionService.hasPermission('interations_report') ||
      this.permissionService.hasPermission('aetna_report') ||
      this.permissionService.hasPermission('view-reports');

    if (hasAccess) {
      return true;
    }

    this.notification.show(
      'warning',
      'Sin acceso',
      'No tienes permisos para acceder al módulo de reportes.',
      'topRight',
    );
    this.router.navigate(['/pages/dashboard'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  }
}
